import * as z from "zod";
import { askRedoExplorerFilters } from "./get-explorer-threads";

// Exports all threads matching the explorer filters as CSV (unpaginated, row
// capped via `capped`).
export const exportAskRedoExplorerThreadsCsv = {
  name: "exportAskRedoExplorerThreadsCsv" as const,

  input: askRedoExplorerFilters,

  output: z.object({
    csv: z.string(),
    rowCount: z.number(),
    totalMatched: z.number(),
    capped: z.boolean(),
  }),
};
